var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCustomerRating(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_162)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9998 9.96368C18.2794 9.96368 20.1339 8.10912 20.1339 5.82962C20.1339 3.55012 18.2793 1.69556 15.9998 1.69556C13.7202 1.69556 11.8657 3.55012 11.8657 5.82962C11.8657 8.10912 13.7202 9.96368 15.9998 9.96368Z",
    fill: "#25AA4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33294 19.9211H22.6667C23.2179 19.9211 23.6647 19.4742 23.6647 18.9231C23.6647 14.6967 20.2262 11.2583 15.9999 11.2583C11.7735 11.2583 8.335 14.6967 8.335 18.9231C8.335 19.4742 8.78181 19.9211 9.33294 19.9211Z",
    fill: "#25AA4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0274 23.7516L17.8629 23.4371L16.8949 21.4757C16.5294 20.7351 15.4704 20.7356 15.1051 21.4757L14.1371 23.4371L11.9726 23.7516C11.1553 23.8704 10.8285 24.8776 11.4196 25.4537L12.9857 26.9804L12.616 29.1362C12.4764 29.9502 13.3333 30.5722 14.0639 30.1882L15.9999 29.1704L17.9359 30.1882C18.6606 30.5692 19.5246 29.9563 19.3839 29.1362L19.0141 26.9804L20.5803 25.4537C21.1718 24.8772 20.8442 23.8703 20.0274 23.7516Z",
    fill: "#25AA4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.90938 23.7516L6.74487 23.437L5.77688 21.4757C5.41138 20.7351 4.35244 20.7355 3.98712 21.4757L3.01919 23.437L0.854687 23.7516C0.0373749 23.8703 -0.289375 24.8776 0.301625 25.4537L1.86781 26.9804L1.49806 29.1361C1.35844 29.9502 2.21537 30.5722 2.946 30.1881L4.882 29.1703L6.818 30.1881C7.54269 30.5691 8.40663 29.9563 8.26594 29.1361L7.89619 26.9804L9.46244 25.4537C10.0539 24.8771 9.72619 23.8703 8.90938 23.7516Z",
    fill: "#25AA4A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1452 23.7516L28.9807 23.437L28.0128 21.4757C27.713 20.8682 27.0513 20.9194 27.1179 20.9194C26.7381 20.9194 26.3912 21.1351 26.2231 21.4757L25.2551 23.437L23.0906 23.7516C22.2732 23.8703 21.9465 24.8776 22.5375 25.4537L24.1038 26.9804L23.7341 29.1362C23.5944 29.9502 24.4513 30.5722 25.182 30.1882L27.118 29.1703L29.054 30.1882C29.7787 30.5692 30.6426 29.9563 30.5019 29.1362L30.1322 26.9804L31.6984 25.4537C32.2897 24.8773 31.9622 23.8703 31.1452 23.7516Z",
    fill: "#25AA4A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_162"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerRating);
export default __webpack_public_path__ + "static/media/customer_rating.485d27623394ca08c02fa17b681b382e.svg";
export { ForwardRef as ReactComponent };